import request from '@/utils/request'
let FinanceApi = {
    /*列表*/
    getList(data) {
        return request._post('/shop/plus.finance.bank/index', data);
    },
    add(data) {
        return request._post('/shop/plus.finance.bank/add', data);
    },
    edit(data) {
        return request._post('/shop/plus.finance.bank/edit', data);
    },
    del(data) {
        return request._post('/shop/plus.finance.bank/del', data);
    },

    /*获取提现记录*/
    getCashList(data) {
        return request._post('/shop/plus.finance.bank/getCashList', data);
    },
}

export default FinanceApi;



// WEBPACK FOOTER //
// ./src/api/finance.js